module.exports = __webpack_public_path__ + "static/media/logo-uai-v2.4bb3f2db.png";